// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1if3A","header":"ReportDetails_header__3aDnL","title":"ReportDetails_title__2qMbI","left":"ReportDetails_left__uhtdf"};